<template>
    <div class="offer-view">
        <section class="page-header py-5 bg-light">
            <div class="container">
                <h1 class="display-5 fw-bold">Nasza oferta</h1>
                <p class="lead">Kompleksowe usługi księgowe, podatkowe i kadrowo-płacowe dla Twojej firmy.</p>
            </div>
        </section>

        <section class="offer-content py-5">
            <div class="container">
                <div class="row mb-5">
                    <div class="col-lg-8">
                        <h2 class="mb-4">Czym się zajmujemy</h2>
                        <p>Biuro rachunkowe to profesjonalna firma świadcząca usługi księgowe, podatkowe oraz
                            kadrowo-płacowe dla przedsiębiorców, organizacji i osób prywatnych. Naszym głównym celem
                            jest zapewnienie prawidłowego prowadzenia rozliczeń finansowych zgodnie z obowiązującymi
                            przepisami prawa.</p>
                    </div>
                </div>

                <div class="row mb-5">
                    <div class="col-lg-12">
                        <h3 class="mb-4">Zakres usług biura rachunkowego</h3>
                    </div>

                    <div class="col-lg-12 mb-5" v-for="(service, index) in services" :key="index">
                        <div class="service-block p-4 mb-4 bg-white rounded shadow-sm">
                            <h4 class="service-title d-flex align-items-center">
                                <i :class="service.icon + ' me-3'"></i>
                                {{ service.title }}
                            </h4>
                            <div class="service-content mt-3">
                                <p>{{ service.description }}</p>
                                <ul class="mt-3">
                                    <li v-for="(item, i) in service.items" :key="i">{{ item }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12">
                        <div class="summary-block p-4 bg-light rounded">
                            <h3>Podsumowanie</h3>
                            <p>Biuro rachunkowe to kluczowy partner dla każdej firmy, który dba o prawidłowe prowadzenie
                                księgowości, terminowe rozliczenia podatkowe i sprawy kadrowe. Dzięki niemu
                                przedsiębiorca może skupić się na rozwoju biznesu, mając pewność, że wszystkie
                                formalności są prowadzone zgodnie z obowiązującymi przepisami.</p>

                            <div class="benefits-list mt-4">
                                <h4>Korzyści wynikające ze współpracy z biurem rachunkowym:</h4>
                                <ul class="mt-3">
                                    <li><i class="fas fa-check-circle text-success me-2"></i> Oszczędność czasu –
                                        przedsiębiorca może skupić się na prowadzeniu biznesu, zamiast zajmować się
                                        formalnościami księgowymi.</li>
                                    <li><i class="fas fa-check-circle text-success me-2"></i> Minimalizacja ryzyka
                                        błędów – księgowi dbają o poprawność dokumentacji i zgodność z przepisami.</li>
                                    <li><i class="fas fa-check-circle text-success me-2"></i> Bezpieczeństwo i
                                        aktualność przepisów – biura rachunkowe na bieżąco śledzą zmiany w prawie
                                        podatkowym i dostosowują do nich sposób rozliczeń klientów.</li>
                                    <li><i class="fas fa-check-circle text-success me-2"></i> Optymalizacja kosztów –
                                        profesjonalne doradztwo może pomóc w zmniejszeniu obciążeń podatkowych.</li>
                                </ul>
                            </div>

                            <div class="text-center mt-4">
                                <router-link to="/kontakt" class="btn btn-primary btn-lg">Skontaktuj się z
                                    nami</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'OfferView',
    data() {
        return {
            services: [
                {
                    title: 'Prowadzenie księgowości',
                    description: 'Obsługujemy różne formy księgowości, dostosowane do rodzaju działalności klienta:',
                    icon: 'fas fa-book',
                    items: [
                        'Pełna księgowość – dotyczy spółek z o.o., spółek akcyjnych oraz innych podmiotów zobowiązanych do prowadzenia ksiąg rachunkowych zgodnie z ustawą o rachunkowości.',
                        'Księga przychodów i rozchodów (KPiR) – uproszczona forma księgowości dla osób prowadzących jednoosobową działalność gospodarczą oraz niektórych spółek.',
                        'Ewidencja przychodów (ryczałt) – stosowana przez przedsiębiorców rozliczających się na zasadzie ryczałtu ewidencjonowanego.'
                    ]
                },
                {
                    title: 'Rozliczenia podatkowe i obsługa zobowiązań wobec urzędów',
                    description: 'Odpowiadamy za prawidłowe naliczanie podatków oraz ich terminowe rozliczanie z urzędem skarbowym:',
                    icon: 'fas fa-file-invoice-dollar',
                    items: [
                        'Rozliczenia VAT – sporządzanie deklaracji VAT-7 lub VAT-UE oraz wysyłanie ich do urzędu skarbowego.',
                        'Podatek dochodowy (PIT, CIT) – obliczanie należnego podatku dochodowego od osób fizycznych (PIT) i osób prawnych (CIT).',
                        'Jednolity Plik Kontrolny (JPK) – przygotowanie i wysyłka plików JPK_VAT oraz innych struktur wymaganych przez administrację skarbową.'
                    ]
                },
                {
                    title: 'Obsługa kadrowo-płacowa',
                    description: 'Zajmujemy się także sprawami kadrowo-płacowymi, co obejmuje:',
                    icon: 'fas fa-users',
                    items: [
                        'Przygotowanie listy płac – obliczanie wynagrodzeń dla pracowników, w tym dodatków, premii i potrąceń.',
                        'Zgłoszenia i rozliczenia ZUS – rejestrowanie pracowników w ZUS, obliczanie składek na ubezpieczenia społeczne, zdrowotne i FP.',
                        'Prowadzenie akt osobowych pracowników – sporządzanie umów o pracę, umów cywilnoprawnych (zlecenie, dzieło) oraz ich rozliczanie.'
                    ]
                },
                {
                    title: 'Sporządzanie sprawozdań finansowych',
                    description: 'Przygotowujemy roczne sprawozdania finansowe, bilanse i rachunki wyników, które są wymagane przez urzędy skarbowe, ZUS czy GUS.',
                    icon: 'fas fa-chart-pie',
                    items: []
                },
                {
                    title: 'Reprezentacja przed urzędami',
                    description: 'Zapewniamy profesjonalną reprezentację:',
                    icon: 'fas fa-university',
                    items: [
                        'Kontakt z urzędem skarbowym i ZUS – działamy jako pełnomocnik klienta, odpowiadając na pisma urzędowe, składając wyjaśnienia i pomagając w kontrolach podatkowych.',
                        'Sporządzanie odwołań i wniosków – np. o interpretacje podatkowe, zwrot nadpłaconych podatków lub korekty deklaracji.'
                    ]
                },
                // {
                //     title: 'Doradztwo podatkowe i finansowe',
                //     description: 'Pomagamy w optymalizacji podatkowej i wyborze najkorzystniejszych rozwiązań dla firmy:',
                //     icon: 'fas fa-comments-dollar',
                //     items: [
                //         'Wybór formy opodatkowania (np. ryczałt, skala podatkowa, podatek liniowy).',
                //         'Planowanie kosztów i optymalizacja podatkowa.',
                //         'Analiza rentowności przedsiębiorstwa i pomoc w podejmowaniu decyzji finansowych.'
                //     ]
                // }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.offer-view {
    .page-header {
        background-color: #f1f8ff;

        h1 {
            color: var(--primary-color);
        }
    }

    .service-block {
        border-left: 4px solid var(--secondary-color);
        transition: transform 0.3s ease;

        &:hover {
            transform: translateY(-5px);
        }

        .service-title {
            color: var(--primary-color);

            i {
                color: var(--secondary-color);
            }
        }

        ul li {
            margin-bottom: 0.8rem;
            line-height: 1.6;
        }
    }

    .summary-block {
        background-color: #f8f9fa;
        border-radius: 10px;

        h3 {
            color: var(--primary-color);
            margin-bottom: 1rem;
        }

        .benefits-list {
            h4 {
                color: var(--primary-color);
            }

            ul {
                list-style: none;
                padding-left: 0;

                li {
                    margin-bottom: 0.8rem;
                    line-height: 1.6;
                }
            }
        }
    }
}
</style>